module.exports = __webpack_public_path__ + "static/media/key.48b96a3d.svg";